import React from 'react';
import type { FC } from 'react';

import { SelectFormGroup, type SelectFormGroupProps } from '@admin/components/fields/select_form_group';
import { Vehicle__OwnershipKind } from '@admin/schema';

const OPTIONS = [
  { value: Vehicle__OwnershipKind.Owned, name: 'Owned' },
  { value: Vehicle__OwnershipKind.Leased, name: 'Leased' },
  { value: Vehicle__OwnershipKind.Rented, name: 'Rented' },
];

export type OwnershipKindSelectFormGroupProps = Omit<SelectFormGroupProps, 'value' | 'children' | 'onChange'> & {
  value?: Vehicle__OwnershipKind;
  onChange(value: Vehicle__OwnershipKind | undefined): void;
};

export const OwnershipKindSelectFormGroup: FC<OwnershipKindSelectFormGroupProps> = ({ value, onChange, ...props }) => (
  <SelectFormGroup
    {...props}
    value={value ?? ''}
    onChange={(event) => onChange((event.target.value || undefined) as Vehicle__OwnershipKind)}
  >
    <option value=""> - All - </option>

    {OPTIONS.map((option, key) => (
      <option value={option.value} key={key}>
        {option.name}
      </option>
    ))}
  </SelectFormGroup>
);
